const CALLABLE_PREFIX = 'callables_';

export const getAllUsers = (functions) => {
    return functions.httpsCallable(CALLABLE_PREFIX + 'getAllUsers');
};
